import { NavList } from '@cpm-pr1618001/ng-design-lib';
import { HttpRequestStatus } from '@cpm-pr1618003/ng-initializer-lib';

export interface UpdateProfileInfoAddress {
  addressLine1: string;
  addressLine2?: string;
  state: string;
  country: string;
  zip: string;
}

export interface UpdateProfileInfoPayload {
  accountDetails: {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    address?: UpdateProfileInfoAddress;
  };
}

export interface SettingsState {
  settingsTabs: NavList[];
  updateProfileInfoStatus: HttpRequestStatus;
  sendDeleteVerificationCodeStatus: HttpRequestStatus;
  deleteAccountStatus: HttpRequestStatus;
  deleteAccountErrorMessage: string | null;
}

export const initialSettingsState: SettingsState = {
  settingsTabs: [],
  updateProfileInfoStatus: HttpRequestStatus.Idle,
  sendDeleteVerificationCodeStatus: HttpRequestStatus.Idle,
  deleteAccountStatus: HttpRequestStatus.Idle,
  deleteAccountErrorMessage: null,
};
